import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { DebounceInput, DebounceInputProps } from "react-debounce-input";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";
import Selector from "../../../../components/selector";

export const PriceLine = styled.div<{ firstItem?: boolean }>`
  display: flex;
  align-items: ${props => (props.firstItem ? "center" : "baseline")};

  & > *:first-child {
    margin-right: 10px;
  }

  & > *:nth-child(2) {
    margin-right: 10px;
  }
`;

export const CloseIcon = styled.span`
  cursor: pointer;
  height: auto;
`;

export const NetPriceTotalWrapper = styled.div`
  margin-top: 20px;
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.greyBorder};
  padding-bottom: 30px;
  margin-bottom: 30px;
`;

export const ExtrasTotal = styled.h6`
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.greyBorder};
  padding-bottom: 30px;
  margin-bottom: 50px;
`;

export const GrandTotalWrapper = styled.h5`
  font-weight: 600;
  margin-bottom: 25px;
`;

export const Extras = styled.div`
  margin-top: 15px;
  margin-bottom: 30px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 110px 110px 110px 95px 95px 0 minmax(150px, max-content) minmax(
      150px,
      max-content
    );
  grid-template-rows: 50px;
  grid-auto-rows: 25px;
  column-gap: 20px;
  input:not([type="radio"]) {
    width: auto;
  }
`;

export const GridCell = styled.div`
  padding: 5px;
  border: solid ${({ theme }) => theme.greyBorder};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const GridDate = styled(GridCell)<{ header?: boolean; bold?: boolean; error?: boolean }>`
  justify-content: ${props => (props.header ? `center` : `right`)};
  text-align: ${props => (props.header ? `center` : `inherit`)};
  font-weight: ${props => (props.header || props.bold ? `600` : `400`)};
  border-width: ${props => (props.header ? `1px;` : `0 1px 1px 1px;`)};
  grid-column-start: 1;
  grid-column-end: 1;
  ${props =>
    props.error &&
    `
    background-color: #f4dbdb;
    color: #b20e0e;
    border-color: #b20e0e;
  `}
`;
export const GridAriPrice = styled(GridCell)<{ header?: boolean; bold?: boolean }>`
  background-color: ${({ theme }) => theme.greyBackground};
  font-weight: ${props => (props.header || props.bold ? `600` : `400`)};
  border-width: ${props => (props.header ? `1px;` : `0 1px 1px 1px;`)};
  grid-column-start: 2;
  grid-column-end: 2;
  display: flex;
  justify-content: center;
  position: relative;
  & > .styled-font-awesome-icon-wrapper {
    position: absolute;
    right: 5px;
  }
`;

export const GridAppliedPrice = styled(GridCell)<{ header?: boolean; bold?: boolean }>`
  text-align: ${props => (props.header ? `center` : `inherit`)};
  font-weight: ${props => (props.header || props.bold ? `600` : `400`)};
  border-width: ${props => (props.header ? `1px;` : `0 1px 1px 1px;`)};
  grid-column-start: 3;
  grid-column-end: 3;
`;

export const GridDiscount = styled(GridCell)<{ header?: boolean; bold?: boolean }>`
  text-align: ${props => (props.header ? `center` : `inherit`)};
  font-weight: ${props => (props.header || props.bold ? `600` : `400`)};
  border-width: ${props => (props.header ? `1px;` : `0 1px 1px 1px;`)};
  grid-column-start: 4;
  grid-column-end: 4;
  & > span:first-child {
    margin-left: 10px;
  }
`;
export const GridAppliedPriceInput = styled(DebounceInput)<
  {
    header?: boolean;
    disabled: boolean;
    placeholder: string;
    bold?: boolean;
  } & DebounceInputProps<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>
>`
  color: ${({ theme }) => theme.regularTextColor};
  text-align: center;
  padding: 5px;
  border: solid ${({ theme }) => theme.greyBorder};
  font-weight: ${props => (props.header || props.bold ? `600` : `400`)};
  border-width: ${props => (props.header ? `1px;` : `0 1px 1px 1px;`)};
  grid-column-start: 3;
  grid-column-end: 3;
`;

export const GridDiscountInput = styled(DebounceInput)<
  { header?: boolean; disabled: boolean; bold?: boolean } & DebounceInputProps<
    HTMLInputElement,
    React.InputHTMLAttributes<HTMLInputElement>
  >
>`
  color: ${({ theme }) => theme.regularTextColor};
  text-align: center;
  padding: 5px;
  border: solid ${({ theme }) => theme.greyBorder};
  font-weight: ${props => (props.header || props.bold ? `600` : `400`)};
  border-width: ${props => (props.header ? `1px;` : `0 1px 1px 1px;`)};
  grid-column-start: 4;
  grid-column-end: 4;
`;

export const GridFinalPrice = styled(GridCell)<{ header?: boolean; bold?: boolean }>`
  background-color: ${({ theme }) => theme.greyBackground};
  text-align: center;
  font-weight: ${props => (props.header || props.bold ? `600` : `400`)};
  border-width: ${props => (props.header ? `1px;` : `0 1px 1px 1px;`)};
  grid-column-start: 5;
  grid-column-end: 5;
  display: flex;
  justify-content: center;
  position: relative;
  & > svg {
    position: absolute;
    right: -18px;
  }
`;

export const GridSeparator = styled(GridCell)<{ header?: boolean; bold?: boolean }>`
  text-align: ${props => (props.header ? `center` : `inherit`)};
  font-weight: ${props => (props.header || props.bold ? `600` : `400`)};
  border-width: 0 1px 0 0;
  padding: 0;
  grid-column-start: 6;
  grid-column-end: 6;
`;

export const GridRestrictions = styled(GridCell)<{ header?: boolean; bold?: boolean }>`
  justify-content: ${props => (props.header ? `center` : `space-between`)};
  font-weight: ${props => (props.header || props.bold ? `600` : `400`)};
  border-width: ${props => (props.header ? `1px;` : `0 1px 1px 1px;`)};
  grid-column-start: 7;
  grid-column-end: 7;
  display: flex;
  & > *:first-child {
    margin-right: 10px;
`;

export const GridPromos = styled(GridCell)<{ header?: boolean; bold?: boolean }>`
  justify-content: ${props => (props.header ? `center` : `space-between`)};
  font-weight: ${props => (props.header || props.bold ? `600` : `400`)};
  border-width: ${props => (props.header ? `1px;` : `0 1px 1px 1px;`)};
  grid-column-start: 8;
  grid-column-end: 8;
  display: flex;
  & > *:first-child {
    margin-right: 10px;
  }
`;

export const BookingDetails = styled.div`
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.greyBorder};
  padding-bottom: 30px;
  margin-bottom: 30px;
`;

export const StyledFontAwesomeIconWrapper = styled.span`
  border-radius: 25px;
  background-color: ${({ theme }) => theme.buttonColor};
  color: ${({ theme }) => theme.buttonLightBorder};
  cursor: pointer;
  max-width: 15px;
  min-width: 15px;
  max-height: 15px;
  min-height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  border-radius: 25px;
  background-color: ${({ theme }) => theme.buttonColor};
  color: ${({ theme }) => theme.buttonLightBorder};
  cursor: pointer;
  max-width: 15px;
  min-width: 15px;
  max-height: 15px;
  min-height: 15px;
`;

export const StyledModificationPriceManagement = styled.div`
  margin-top: 15px;

  & input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const RestrictionsStyledTable = styled.table`
  border: 1px solid;
  border-bottom: 0;
  border-color: ${({ theme }) => theme.greyBorder};
  border-collapse: collapse;
  tr {
    border: 0.5px solid;
    border-color: ${({ theme }) => theme.greyBorder};
  }
  td {
    border: 0.5px solid;
    border-color: ${({ theme }) => theme.greyBorder};
    padding: 5px 20px;
  }
`;

export const PromosStyledTable = styled.table`
  margin: auto;
  border-color: ${({ theme }) => theme.greyBorder};
  border-collapse: collapse;
  tr,
  td,
  th {
    border: 0.5px solid;
    border-color: ${({ theme }) => theme.greyBorder};
    padding: 5px 20px;
  }
`;

export const PromosStyledTableWrapper = styled.div`
  width: 100%;
  overflow: auto;
`;

export const RestrictionsTableWrapper = styled.span`
  display: flex;
  justify-content: center;
  & > *:first-child {
    margin-right: 20px;
  }
`;

export const StyledSelector = styled(Selector)`
  margin-bottom: 10px;
`;
export const DatePickerGroupWrapper = styled.div`
  .react-datepicker__close-icon::after {
    background-color: ${({ theme }) => theme.buttonColor};
  }
`;

export const StyledModal = styled(Modal)<{ width?: string }>`
  font-size: 12px;
  .modal-header {
    background-color: ${({ theme }) => theme.regularTextColor};
    color: ${({ theme }) => theme.buttonLightBorder};
  }
  .close {
    color: ${({ theme }) => theme.buttonLightBorder};
    font-size: 17px;
  }
  .styled-modal {
    width: ${props => (props.width ? props.width : "70vw")};
    max-width: ${props => (props.width ? props.width : "70vw")};
  }
`;

export const StyledModalHeader = styled(Modal.Header)`
  font-size: 17px;
`;

export const ModalTableHeaderWrapper = styled.div`
  & > div:nth-child(2) {
    font-weight: 600;
  }
  margin-bottom: 10px;
`;

export const StyledReactTooltip = styled(ReactTooltip)`
  text-transform: none;
  white-space: pre-wrap;
`;

export const HelpTextMessageNoMargin = styled.div``;
export const HelpTextMessage = styled.div`
  margin-bottom: 20px;
`;

export const StyledDropdown = styled(Dropdown)`
  width: 100%;
`;

export const StyledDropdownMenu = styled(Dropdown.Menu)`
  width: 100%;
  max-height: 300px;
  overflow: hidden;
  overflow-y: scroll;
`;

export const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  color: #808080;
  font-weight: 600;
  cursor: pointer;

  input {
    cursor: pointer;
  }

  span {
    margin-left: 8px;
  }
`;
